import { useFormContext } from "@/app/components/formContext/formcontext";
import { useEffect } from "react";
import { withServicesLayout } from "@/pages/_layoutService";

function Cnpj() {
  const { setOptions } = useFormContext();

  const models = ["Corolla Sedan", "Hilux", "Hiace"];

  useEffect(() => {
    setOptions([...models]);
  }, []);

  return (
    <>
      <div className="w-full text-zinc-800 p-3">
        <div className="w-full  h-36 mt-5 lg:p-3 ">
          <h1 className="text-[40px]  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            CNPJ
          </h1>
          <div className="w-16 border-b-2 ml-1 border-red-600 " />
        </div>
        <p className="mt-10">
          A Venda Direta da Toyota oferece uma solução eficiente e personalizada
          para empresas que compram como Pessoa Jurídica. A Toyota é reconhecida
          mundialmente pela qualidade e confiabilidade de seus veículos. Nossos
          carros são projetados para proporcionar desempenho superior, economia
          de combustível e baixos custos de manutenção, garantindo eficiência
          para o seu negócio. Além de vantagens exclusivas, todos os modelos
          estão cobertos pela garantia de dez anos ou 100 mil km. Não perca mais
          tempo e adquira seu veículo com condições especiais para empresas.
        </p>
        <h2 className="text-2xl py-5">Documentações necessárias:</h2>
        <p className="pb-5">
          - Ficha cadastral de Empresário individual ou Contrato Social ou Ato
          Constitutivo;
          <br />
          - Ata de eleição da Diretoria e/ou Procuração se houver;
          <br />
          - RG/CPF ou documento equivalente do administrador ou representante
          legal da empresa;
          <br />
          - Cartão CNPJ (Situação Ativa);
          <br />- Inscrição Estadual (Situação Regular)
        </p>
      </div>
    </>
  );
}

export default withServicesLayout(Cnpj);
export { getServerSideProps } from "@/pages/_layoutService";
